var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import { useStableOkapiKy } from "./useStableOkapiKy";
import { LegalPersonStatusEnum } from "../types/Api";
import { useModal } from "../utils/useModal";
import { useApiAction } from "../utils/useApiAction";
import { useDetailParam } from "../utils/detailParam";
import { usePermissions } from "./usePermissions";
import { useGetCurrentUser } from "../utils/useCurrentUser";
import { deleteLegalPerson, fetchLegalPersonById, } from "../api/legalPersonService";
import { buildPersonDeleteErrorMessage, parsePersonDeleteError, } from "../utils/personDeleteErrors";
export var useLegalPersonActions = function () {
    var ky = useStableOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _a = useModal(), isOpen = _a.isOpen, message = _a.message, action = _a.action, openModal = _a.openModal, closeModal = _a.closeModal;
    var performAction = useApiAction().performAction;
    var _b = useState(false), errorOpen = _b[0], setErrorOpen = _b[1];
    var _c = useState(""), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = useDetailParam(), detailId = _d.detailId, updateDetailParam = _d.updateDetailParam;
    var _e = usePermissions(), canEditLegalPerson = _e.canEditLegalPerson, canDeleteLegalPerson = _e.canDeleteLegalPerson, isSuperUser = _e.isSuperUser, isPublisher = _e.isPublisher;
    var currentUser = useGetCurrentUser().data;
    var _f = useState(null), selectedLegalPerson = _f[0], setSelectedLegalPerson = _f[1];
    useEffect(function () {
        var fetchItem = function () { return __awaiter(void 0, void 0, void 0, function () {
            var item, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(detailId && (selectedLegalPerson === null || selectedLegalPerson === void 0 ? void 0 : selectedLegalPerson.id) !== detailId)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetchLegalPersonById(ky, detailId)];
                    case 2:
                        item = _a.sent();
                        if (item) {
                            setSelectedLegalPerson(item);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        setSelectedLegalPerson(null);
                        updateDetailParam(null);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        if (!detailId) {
                            setSelectedLegalPerson(null);
                        }
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        fetchItem();
    }, [ky, selectedLegalPerson, detailId, updateDetailParam]);
    var handleRowClick = function (item) {
        updateDetailParam(item.id);
        setSelectedLegalPerson(item);
    };
    var handleDelete = function (itemId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2, deleteError;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 4]);
                    return [4 /*yield*/, performAction({
                            apiCall: function () { return deleteLegalPerson(ky, itemId); },
                            queryKey: "legal-persons",
                            errorMsg: formatMessage({
                                id: "ui-br-agency.legal-person.error.delete",
                            }),
                            onSuccess: function () {
                                setSelectedLegalPerson(null);
                                updateDetailParam(null);
                                closeModal();
                            },
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    error_2 = _a.sent();
                    return [4 /*yield*/, parsePersonDeleteError(error_2)];
                case 3:
                    deleteError = _a.sent();
                    setErrorMessage(buildPersonDeleteErrorMessage(formatMessage, "legal-person", deleteError));
                    setErrorOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var openDeleteConfirm = function (item) {
        var displayName = item.name || item.id;
        openModal(formatMessage({ id: "ui-br-agency.legal-person.delete.confirm" }, { name: displayName }), function () { return handleDelete(item.id); });
    };
    var handleCloseDetail = function () {
        setSelectedLegalPerson(null);
        updateDetailParam(null);
    };
    var canEditSelectedPerson = useMemo(function () {
        var _a, _b;
        if (!selectedLegalPerson)
            return false;
        var hasProposalStatus = selectedLegalPerson.status === LegalPersonStatusEnum.PROPOSAL;
        var isUserProposer = isSuperUser ||
            (((_a = selectedLegalPerson.proposer) === null || _a === void 0 ? void 0 : _a.sourceId) &&
                currentUser &&
                ((_b = currentUser.activeOrganization) === null || _b === void 0 ? void 0 : _b.sourceId) ===
                    selectedLegalPerson.proposer.sourceId);
        return canEditLegalPerson && hasProposalStatus && isUserProposer;
    }, [selectedLegalPerson, canEditLegalPerson, isSuperUser, currentUser]);
    var canReportChange = useMemo(function () {
        if (!selectedLegalPerson)
            return false;
        return (isPublisher &&
            (selectedLegalPerson === null || selectedLegalPerson === void 0 ? void 0 : selectedLegalPerson.status) === LegalPersonStatusEnum.CONFIRMED);
    }, [selectedLegalPerson, isPublisher]);
    var canDeleteSelectedPerson = useMemo(function () {
        var _a, _b;
        if (!selectedLegalPerson)
            return false;
        var hasProposalStatus = selectedLegalPerson.status === LegalPersonStatusEnum.PROPOSAL;
        var isUserProposer = isSuperUser ||
            (((_a = selectedLegalPerson.proposer) === null || _a === void 0 ? void 0 : _a.sourceId) &&
                currentUser &&
                ((_b = currentUser.activeOrganization) === null || _b === void 0 ? void 0 : _b.sourceId) ===
                    selectedLegalPerson.proposer.sourceId);
        return canDeleteLegalPerson && hasProposalStatus && isUserProposer;
    }, [selectedLegalPerson, canDeleteLegalPerson, isSuperUser, currentUser]);
    var closeError = function () { return setErrorOpen(false); };
    return {
        selectedLegalPerson: selectedLegalPerson,
        /** Replaces the shown person, e.g. after an NK authority link action (DB-635). */
        setSelectedLegalPerson: setSelectedLegalPerson,
        isModalOpen: isOpen,
        modalMessage: message,
        modalAction: action,
        handleRowClick: handleRowClick,
        openDeleteConfirm: openDeleteConfirm,
        handleCloseDetail: handleCloseDetail,
        closeModal: closeModal,
        canEditSelectedPerson: canEditSelectedPerson,
        canReportChange: canReportChange,
        canDeleteSelectedPerson: canDeleteSelectedPerson,
        errorOpen: errorOpen,
        errorMessage: errorMessage,
        closeError: closeError,
    };
};
